import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Container
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, NavLink } from 'react-router-dom';

const navItems = [
  { label: 'About', to: '/about' },
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Comparison', to: '/comparison' },
  { label: 'Paper', to: '/paper' },
  { label: 'Glossary', to: '/glossary' },
];

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar
      position="sticky"
      sx={{
    top: 0,              // 🔥 important
    marginTop: 0,
    paddingTop: 0,
        bgcolor: '#E0F2FF', // Light blue background
        color: '#0B3D91',   // Dark blue text
        borderBottom: '1px solid #90CAF9', // soft blue border
        backdropFilter: 'saturate(180%) blur(6px)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ display: 'flex', minHeight: "64px !important",
    margin: 0,
    padding: 0, justifyContent: 'space-between', alignItems: 'center', px: 0 }}>
          
          {/* Brand */}
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            component={Link}
            to="/"
            sx={{ textDecoration: 'none', color: 'inherit' }}
          >
            <Typography
              variant="h5" // Increased font size
              sx={{
                fontWeight: 900,
                letterSpacing: 0.5,
                color: '#0B3D91',
                fontFamily: 'Roboto, sans-serif',
              }}
            >
              AthEcoScope
            </Typography>

            {/* PNG Logo */}
            <Box
  component="img"
  src="/bgicon.png"
  alt="Logo"
  sx={{
    height: { xs: 50, md: 60 },
    width: { xs: 50, md: 60 },
    objectFit: 'contain',
    filter: 'brightness(0) saturate(100%) invert(16%) sepia(82%) saturate(5511%) hue-rotate(205deg) brightness(90%) contrast(90%)'
  }}
/>
          </Box>

          {/* Desktop Nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            {navItems.map((n) => (
              <Button
                key={n.to}
                component={NavLink}
                to={n.to}
                sx={{
                  color: '#64B5F6', // light blue nav items
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  fontFamily: 'Arial, sans-serif',
                  '&.active': {
                    fontWeight: 700,
                    borderBottom: (theme) => `2px solid #0B3D91`,
                    borderRadius: 0,
                    color: '#0B3D91',
                  },
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: '#0B3D91',
                  },
                }}
              >
                {n.label}
              </Button>
            ))}
          </Box>

          {/* Mobile Menu */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton onClick={handleOpen} aria-label="menu" sx={{ color: '#0B3D91' }}>
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              {navItems.map((n) => (
                <MenuItem
                  key={n.to}
                  component={Link}
                  to={n.to}
                  onClick={handleClose}
                  sx={{ color: '#0B3D91', fontFamily: 'Arial, sans-serif', fontSize: '1rem' }}
                >
                  {n.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
